<div class="content">
  <automata-automation-replacement-chips
    label="AUTOMATIONS.COMMON.LIST"
    [dataService]="actionListsSelectorService"
    [formControl]="actionListNameControl"
    [isRequired]="true"
    [multiple]="false"
    (finishedInitialLoading)="finishedLoadingSelector()"
  ></automata-automation-replacement-chips>
</div>
